export const CriteriaTypeDetailVisibilityStateEnumValue = {
  Visible: 1,
  Hidden: 2,
};

const criteriaTypeDetailVisibilityStateArray = [
  {
    value: CriteriaTypeDetailVisibilityStateEnumValue.Visible,
    name: 'Visible',
    labelEnglish: 'Visible',
    labelFrench: 'Visible',
  },
  {
    value: CriteriaTypeDetailVisibilityStateEnumValue.Hidden,
    name: 'Hidden',
    labelEnglish: 'Hidden',
    labelFrench: 'Masqué',
  },
];

const CriteriaTypeDetailVisibilityStateEnum = {};
criteriaTypeDetailVisibilityStateArray.forEach(state => {
  CriteriaTypeDetailVisibilityStateEnum[state.value] = state;
});

CriteriaTypeDetailVisibilityStateEnum.array = criteriaTypeDetailVisibilityStateArray;

export const getCriteriaTypeDetailVisibilityStateLabel = (state, language = 'en') => {
  const stateObj = CriteriaTypeDetailVisibilityStateEnum[state];
  if (!stateObj) return 'Unknown';
  return language === 'fr' ? stateObj.labelFrench : stateObj.labelEnglish;
};

export default CriteriaTypeDetailVisibilityStateEnum;
